var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.69,0a.48.48,0,0,0-.54.11L14.5,1.79,12.85.15a.48.48,0,0,0-.7,0L10.5,1.79,8.85.15a.48.48,0,0,0-.7,0L6.5,1.79,4.85.15a.48.48,0,0,0-.7,0L2.5,1.79.85.15A.47.47,0,0,0,.31,0,.5.5,0,0,0,0,.5v23A.49.49,0,0,0,.31,24a.47.47,0,0,0,.54-.11L2.5,22.21l1.65,1.64a.48.48,0,0,0,.7,0L6.5,22.21l1.65,1.64a.48.48,0,0,0,.7,0l1.65-1.64,1.65,1.64a.48.48,0,0,0,.7,0l1.65-1.64,1.65,1.64a.47.47,0,0,0,.35.15.43.43,0,0,0,.19,0A.49.49,0,0,0,17,23.5V.5A.5.5,0,0,0,16.69,0ZM16,22.29l-1.15-1.14a.48.48,0,0,0-.7,0L12.5,22.79l-1.65-1.64a.48.48,0,0,0-.7,0L8.5,22.79,6.85,21.15a.48.48,0,0,0-.7,0L4.5,22.79,2.85,21.15a.48.48,0,0,0-.7,0L1,22.29V1.71L2.15,2.85a.48.48,0,0,0,.7,0L4.5,1.21,6.15,2.85a.48.48,0,0,0,.7,0L8.5,1.21l1.65,1.64a.48.48,0,0,0,.7,0L12.5,1.21l1.65,1.64a.48.48,0,0,0,.7,0L16,1.71ZM10,6.5a.5.5,0,0,1-.5.5h-6a.5.5,0,0,1,0-1h6A.5.5,0,0,1,10,6.5Zm-7,3A.5.5,0,0,1,3.5,9h4a.5.5,0,0,1,0,1h-4A.5.5,0,0,1,3,9.5Zm6,3a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1,0-1h5A.5.5,0,0,1,9,12.5Zm-2,3a.5.5,0,0,1-.5.5h-3a.5.5,0,0,1,0-1h3A.5.5,0,0,1,7,15.5Zm7-9a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1A.5.5,0,0,1,14,6.5Zm0,3a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1A.5.5,0,0,1,14,9.5Zm0,3a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1A.5.5,0,0,1,14,12.5Zm0,3a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1,0-1h1A.5.5,0,0,1,14,15.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.6dad9f5f56f67e08238bbca1bc21f09b.svg";
export { ForwardRef as ReactComponent };